module.exports = __webpack_public_path__ + "static/media/ovaco.d794c852.png";